import { useEffect, useState } from "react";
import { tEnglish as t } from "@buza/i18n";
import { api, type ZdSession } from "./api.js";
import { SignIn } from "./SignIn.js";

// ZD console. Z01 sign-in guards every other screen; screens Z02 to Z08 arrive with their stories.
// Every phrase comes from a key (TRN-01).
export function App() {
  const [session, setSession] = useState<ZdSession | null | undefined>(undefined);

  useEffect(() => {
    document.title = t("console.shell.app_name");
    void api<ZdSession>("/v1/zd/session").then((r) => setSession(r.ok ? r.data : null));
  }, []);

  if (session === undefined) return <main aria-busy="true" />;
  if (session === null) return <SignIn onSignedIn={setSession} />;

  async function signOut() {
    await api("/v1/zd/session", { method: "DELETE" });
    setSession(null);
  }

  return (
    <main>
      <header>
        <h1>{t("console.shell.app_name")}</h1>
        <p>
          {t("console.signin.signed_in_as")} <strong>{session.name}</strong>
        </p>
        <p className="role">{session.role === "super_admin" ? t("console.signin.role_super_admin") : t("console.signin.role_support")}</p>
        <button type="button" onClick={signOut}>
          {t("console.signin.sign_out")}
        </button>
      </header>
      <p>{t("console.shell.coming_soon")}</p>
    </main>
  );
}
